"use strict";
/**
 * Execution statuses returned by AWS events and execution history.
 * https://docs.aws.amazon.com/step-functions/latest/dg/cw-events.html#cw-events-events
 */
exports.__esModule = true;
exports.StepFunctionExecutionStatus = void 0;
var StepFunctionExecutionStatus;
(function (StepFunctionExecutionStatus) {
    StepFunctionExecutionStatus["Started"] = "STARTED";
    StepFunctionExecutionStatus["Running"] = "RUNNING";
    StepFunctionExecutionStatus["Succeeded"] = "SUCCEEDED";
    StepFunctionExecutionStatus["Failed"] = "FAILED";
    StepFunctionExecutionStatus["TimedOut"] = "TIMED_OUT";
    StepFunctionExecutionStatus["Aborted"] = "ABORTED";
})(StepFunctionExecutionStatus = exports.StepFunctionExecutionStatus || (exports.StepFunctionExecutionStatus = {}));
